export default __webpack_public_path__ + "static/media/our-services-edu-nursery.b854e1f7.jpg";